// extracted by mini-css-extract-plugin
module.exports = {"article-content":"article_article-content__6ANmt"};